// Material-UI imports
import { Link, Box } from '@mui/material'
// Utility and function imports
import { formatNumber } from 'utils/helpers'
import { calculateRemainder } from '../../utils/utils'
import { dateFormatter } from 'utils/data-manipulation/valueFormatter'

export const getBulkInvoicePaymentsColumns = (pricePrepend = '$', handlePaymentClick) => [
  {
    field: 'invoiceTicketId',
    headerName: 'Invoice #',
    flex: 1,
    headerAlign: 'left',
    align: 'left',
    renderCell: params => {
      return (
        <Link
          component="button"
          variant="body2"
          onClick={() => handlePaymentClick(params.row)}
          style={{ color: '#009F4D' }}
          data-testid={`invoice-ticket-id-${params.row.id}`}
        >
          {params.row.targetInvoiceNumber || ''}
        </Link>
      )
    },
    sortable: false,
    type: 'string',
  },
  {
    field: 'ticketsCount',
    headerName: 'Tickets',
    flex: 1,
    headerAlign: 'right',
    align: 'right',
    sortable: false,
    type: 'number',
    renderCell: params => <Box data-testid={`outbound-ticket-ids-${params.row.id}`}>{params.value || 0}</Box>,
  },
  {
    field: 'salesOrderNumber',
    headerName: 'SO#',
    flex: 1,
    headerAlign: 'left',
    align: 'left',
    sortable: false,
    type: 'string',
    renderCell: params => <Box data-testid={`sales-order-number-${params.row.id}`}>{params.value || ''}</Box>,
  },
  {
    field: 'dueDate',
    headerName: 'Due Date',
    flex: 1,
    headerAlign: 'left',
    align: 'left',
    valueFormatter: params => {
      return dateFormatter(params.value)
    },
    sortable: false,
    type: 'date',
    renderCell: params => <Box data-testid={`payment-date-${params.row.id}`}>{dateFormatter(params.value)}</Box>,
  },
  {
    field: 'amountDueWhenPaid',
    headerName: 'Amount Due',
    flex: 1,
    headerAlign: 'right',
    align: 'right',
    valueGetter: params => Number(params.row.amountDueWhenPaid || 0),
    valueFormatter: params => `${pricePrepend}${formatNumber(Number(params.value).toFixed(2))}`,
    sortable: false,
    type: 'number',
    renderCell: params => (
      <Box data-testid={`amount-due-${params.row.id}`}>
        {`${pricePrepend}${formatNumber(Number(params.value).toFixed(2))}`}
      </Box>
    ),
  },
  {
    field: 'amount',
    headerName: 'Amount Paid',
    flex: 1,
    headerAlign: 'right',
    align: 'right',
    valueGetter: params => Number(params.row.amount || 0),
    valueFormatter: params => `${pricePrepend}${formatNumber(Number(params.value).toFixed(2))}`,
    sortable: false,
    type: 'number',
    renderCell: params => (
      <Box data-testid={`amount-paid-${params.row.id}`}>
        {`${pricePrepend}${formatNumber(Number(params.value).toFixed(2))}`}
      </Box>
    ),
  },
  {
    field: 'adjustment',
    headerName: 'Adjustment',
    flex: 1,
    headerAlign: 'right',
    align: 'right',
    valueGetter: params => Number(params.row.adjustment || 0),
    valueFormatter: params => `${pricePrepend}${formatNumber(Number(params.value).toFixed(2))}`,
    sortable: false,
    type: 'number',
    renderCell: params => (
      <Box data-testid={`adjustment-${params.row.id}`}>
        {`${pricePrepend}${formatNumber(Number(params.value).toFixed(2))}`}
      </Box>
    ),
  },
  {
    field: 'remainder',
    headerName: 'Remainder',
    flex: 1,
    headerAlign: 'right',
    align: 'right',
    valueGetter: (params: any) => {
      const amountDue = Number(params.row.amountDueWhenPaid || 0)
      const amountPaid = Number(params.row.amount || 0)
      const adjustment = Number(params.row.adjustment || 0)
      return calculateRemainder(amountDue, amountPaid, adjustment)
    },
    valueFormatter: (params: any) => `${pricePrepend}${formatNumber(Number(params.value).toFixed(2))}`,
    sortable: false,
    type: 'number',
    renderCell: params => (
      <Box data-testid={`remainder-${params.row.id}`}>
        {`${pricePrepend}${formatNumber(Number(params.value).toFixed(2))}`}
      </Box>
    ),
  },
]
